/**
 * O TRECHO DA ORDEM, aparado em PALAVRA INTEIRA.
 *
 * O `contexto` do extrator é uma fatia de largura fixa — 80 caracteres antes
 * do prazo, 60 depois —, então começa e termina onde calhar: "ntos que
 * demonstrem a sua renda…". Palavra pela metade não economiza espaço, só faz
 * o olho parar para decifrar.
 *
 * As reticências ficam porque ali HAVIA mais texto. Aparar em silêncio faria
 * a citação parecer a frase inteira — e isto é citação de ordem judicial.
 *
 * Se a fatia foi cortada sabe-se pela POSIÇÃO no texto, não pela caixa da
 * letra: publicação em caixa alta também é cortada no meio da palavra, e um
 * contexto que chegou ao fim do texto termina na palavra inteira (às vezes a
 * do próprio prazo, "15 dias.") e não pode perdê-la.
 */
export function aparadoEmPalavraInteira(
  bruto: string,
  { cortadoNoInicio, cortadoNoFim }: { cortadoNoInicio: boolean; cortadoNoFim: boolean },
): string {
  const texto = bruto.trim();
  const semInicioPartido =
    cortadoNoInicio && /\s/.test(texto) ? texto.replace(/^\S+\s+/, '') : texto;
  const semFimPartido =
    cortadoNoFim && /\s/.test(semInicioPartido)
      ? semInicioPartido.replace(/\s+\S*$/, '')
      : semInicioPartido;
  const abre = cortadoNoInicio ? '…' : '';
  const fecha = cortadoNoFim && !/[.!?…]$/.test(semFimPartido) ? '…' : '';
  return `${abre}${semFimPartido}${fecha}`;
}

/** O trecho de um prazo extraído, aparado, sabendo onde ele está no texto. */
export function trechoDoPrazo(
  prazo: { contexto: string; contexto_inicio: number },
  texto: string | null | undefined,
): string {
  const fimDoTexto = (texto ?? '').trimEnd().length;
  return aparadoEmPalavraInteira(prazo.contexto, {
    cortadoNoInicio: prazo.contexto_inicio > 0,
    cortadoNoFim: prazo.contexto_inicio + prazo.contexto.length < fimDoTexto,
  });
}
